import * as jose from 'jose';
import { useEffect } from 'react';
import { useLocalStorage } from 'usehooks-ts';

import { TOKEN_KEY } from '@core/config/constants';

const isTokenExpired = (token: string): boolean => {
  const p = jose.decodeJwt(token);
  return p.exp !== undefined && p.exp < Math.floor(Date.now() / 1000);
};

export const useToken = () => {
  const [token, setToken] = useLocalStorage<string | null>(TOKEN_KEY, null);

  useEffect(() => {
    if (null !== token && isTokenExpired(token)) {
      setToken(null);
    }
  }, [token, setToken]);

  return { token, setToken };
};
